import * as React from 'react';
import { DataStatus } from '../types';
import ToolTip from './Tooltip';

export interface SegmentHeaderProps {
  title: string;
  subTitle?: string;
  spaceBottom?: boolean;
  tooltipData?: DataStatus;
}

const SegmentHeader: React.FC<SegmentHeaderProps> = ({
  title,
  subTitle,
  spaceBottom = true,
  tooltipData = {} as DataStatus
}) => {
  return (
    <div className={spaceBottom ? 'mb-[18px]' : ''}>
      <h5 className="m-0 p-0 font-nunitoBold text-base">
        {title}
        {tooltipData && tooltipData.message && (
          <>
            <span></span> <ToolTip data={tooltipData} />
          </>
        )}
      </h5>
      {subTitle && (
        <p className="font-nunitoMedium text-[#5b5b5b] m-0 text-xs leading-[18px] mr-[5px] mt-2">{subTitle}</p>
      )}
      {/* {marketFilters && <FilterList filters={marketFilters} />} */}
    </div>
  );
};

export default SegmentHeader;
